module.exports = __webpack_public_path__ + "static/media/cards_color.87114184.jpg";